import React, { useRef } from 'react'
import styles from './Features.module.scss'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

interface Props {
  contents: {
    title: string
    items: {
      num: string
      itemTitle: string | JSX.Element
      description: string
      src: string
    }[]
  }
}

const Features: React.FC<Props> = ({ contents }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.features} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <div className={styles.inner}>
        <h2 className={styles.features__title}>{contents.title}</h2>
        <ul className={styles.feature__wrapper}>
          {contents.items.map((item, i) => (
            <li className={styles.feature__wrapper__item} key={i}>
              <figure className={styles.feature__wrapper__item__image}>
                <img src={item.src} alt="プッシュ配信に優れるZEBRAの特長" width={380} height={380} />
              </figure>
              <p className={styles.feature__wrapper__item__number}>{item.num}</p>
              <h3 className={styles.feature__wrapper__item__title}>{item.itemTitle}</h3>
              <p className={styles.feature__wrapper__item__description}>{item.description}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
export default Features
